import React, {Component} from 'react';
import Slider from 'react-slick';
import Fade from 'react-reveal/Fade';
import Player4 from "../Banner/videobtn4";

class Testimonial extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    next() {
        this.slider.slickNext();
    }

    previous() {
        this.slider.slickPrev();
    }

    state = {
        open: false
    };

    onOpenModal = () => {
        this.setState(prevState => ({
            open: !prevState.open
        }));
    };

    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        let FooterData = this.props.FooterData;
        const {tClass} = this.props;
        return (
            <section className={`${tClass}`} id="testimonial">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 d-flex align-items-center">
                            <div className="testimonial_title">
                                <Fade bottom cascade>
                                    <div className="seo_sec_title wow fadeInUp" data-wow-delay="0.3s">
                                        <h2>Check testimonials of<br/> our satisfied users</h2>
                                        <p>The future of GreenHubLK is a story we’re writing with our customers. And
                                            this is why we do , what we do.!</p>
                                    </div>
                                </Fade>
                                <div className="slider_nav">
                                    <i className="ti-angle-left prev" onClick={this.previous}/>
                                    <i className="ti-angle-right next" onClick={this.next}/>
                                    <br/>
                                    <button className="btn_hover app_btn" onClick={this.onOpenModal}><i
                                        className="ti-control-play"/>&nbsp;&nbsp; Watch Documentary
                                    </button>
                                    <Player4 open={this.state.open} toggleModal={this.onOpenModal}/>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-6 offset-lg-1">
                            <div className="stratup_testimonial_info d-flex align-items-center">
                                <Slider ref={c => (this.slider = c)} className="testimonial_slider_four" {...settings}>
                                    {
                                        FooterData.TestimonialText.map(item => {
                                            return (
                                                <div className="item" key={item.id}>
                                                    <div className="author_img">
                                                        <img src={require("../../img/" + item.image)} alt=""/>
                                                    </div>
                                                    <p>{item.description}</p>
                                                    <h5>{item.authorName}</h5>
                                                    <h6>{item.authorPost}</h6>
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Testimonial;
